import { z } from 'zod';
import { InputJsonValue } from "../inputTypeSchemas/InputJsonValue"
import { CoreNotifySubscriberContactMethodHistoryCategoryTypeSchema } from '../inputTypeSchemas/CoreNotifySubscriberContactMethodHistoryCategoryTypeSchema'

/////////////////////////////////////////
// CORE NOTIFY SUBSCRIBER CONTACT METHOD HISTORY SCHEMA
/////////////////////////////////////////

export const CoreNotifySubscriberContactMethodHistorySchema = z.object({
  category: CoreNotifySubscriberContactMethodHistoryCategoryTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  subscriberId: z.number().int(),
  event: z.string(),
  details: InputJsonValue,
})

export type CoreNotifySubscriberContactMethodHistory = z.infer<typeof CoreNotifySubscriberContactMethodHistorySchema>

export default CoreNotifySubscriberContactMethodHistorySchema;
